import { render, staticRenderFns } from "./bonusAccrualPage.vue?vue&type=template&id=2603ed59"
import script from "./bonusAccrualPage.vue?vue&type=script&lang=ts"
export * from "./bonusAccrualPage.vue?vue&type=script&lang=ts"
import style0 from "./bonusAccrualPage.vue?vue&type=style&index=0&id=2603ed59&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports